import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, ListSubheader } from '@mui/material';
import { Station, stations } from '../services/stationService';

interface StationSelectorProps {
  onStationChange: (station: Station) => void;
  selectedValue?: string;
}

export function StationSelector({ onStationChange, selectedValue }: StationSelectorProps) {
  const handleChange = (event: SelectChangeEvent) => {
    const station = stations.find((s) => s.value === event.target.value);
    if (station) {
      onStationChange(station);
    }
  };

  const renderStationItem = (station: Station) => {
    if (station.isHeader) {
      return (
        <ListSubheader key={station.title} sx={{ backgroundColor: '#f5f5f5', color: 'text.primary', fontWeight: 'bold' }}>
          {station.title}
        </ListSubheader>
      );
    }
    return (
      <MenuItem key={station.value} value={station.value}>
        {station.title}
      </MenuItem>
    );
  };

  return (
    <FormControl sx={{ width: '100%', maxWidth: '400px', display: 'flex', mx: 'auto' }}>
      <InputLabel id="station-select-label">Ski Area</InputLabel>
      <Select
        labelId="station-select-label"
        id="station-select"
        value={selectedValue || ''}
        label="Ski Area"
        onChange={handleChange}
      >
        <MenuItem value="">Select a Ski Area</MenuItem>
        {stations.map(renderStationItem)}
      </Select>
    </FormControl>
  );
}
